import BaseApi from "./base-api";

class CountriesStatesApi extends BaseApi {
  get = () => {
    return this.httpGet(`${this.baseUrl}/api/v1/get_countries_and_states.json`);
  };
}

export default new CountriesStatesApi();
